export const EXTENSION_EVENTS = Object.freeze({
  EXTENSION_BUTTON_CLICK: {
    name: 'extension_button_click',
    category: 'Extension',
    description: '插件悬浮按钮点击',
    requiredParams: [],
    optionalParams: []
  },
  EXTENSION_CONTEXT_MENU: {
    name: 'extension_context_menu',
    category: 'Extension',
    description: '右键菜单点击',
    requiredParams: [],
    optionalParams: []
  },
  EXTENSION_IMAGE_ANALYSIS: {
    name: 'extension_image_analysis',
    category: 'Extension',
    description: '图片分析开始',
    requiredParams: [],
    optionalParams: []
  },
  EXTENSION_ICON_CLICK: {
    name: 'extension_icon_click',
    category: 'Extension',
    description: '插件浏览器图标点击',
    requiredParams: [],
    optionalParams: []
  }
});
